import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { resetPassword } from './actions';
import ResetPasswordForm from './ResetPasswordForm';
import { Redirect } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import queryString from 'query-string';
import ReduxBlockUi from 'react-block-ui/redux';
import { RESET_PASSWORD_REQUEST, RESET_PASSWORD_SUCCESS, RESET_PASSWORD_FAILURE } from './actions';

class ResetPassword extends React.Component {

	constructor(props) {
		super(props);
		this.handleResetPasswordSubmit = this.handleResetPasswordSubmit.bind(this);
	}

	handleResetPasswordSubmit(values) {
		const { resetPassword, history } = this.props;

		resetPassword(values, history);
	}

	render() {
		if (this.props.isAuthenticated) {
			const { from } = this.props.location.state || { from: { pathname: '/' } };
			return <Redirect to={from} />;
		}

		const { t, passwordResetToken } = this.props;

		return (
			<div className='franchise-portal'>
				<ReduxBlockUi block={RESET_PASSWORD_REQUEST} unblock={[RESET_PASSWORD_SUCCESS, RESET_PASSWORD_FAILURE]}>
					<div className='box-login'>
						<h3>{t('FO_ResetPassword_Title')}</h3>
						<p>{t('FO_ResetPassword_Text')}</p>
						<ResetPasswordForm onSubmit={this.handleResetPasswordSubmit} initialValues={{ passwordResetToken }} />
					</div>
				</ReduxBlockUi>
			</div>
		);
	}
}

ResetPassword.propTypes = {
	resetPassword: PropTypes.func,
	location: PropTypes.object,
	isAuthenticated: PropTypes.bool
};

const mapStateToProps = (state, ownProps) => {
	const { passwordResetToken } = queryString.parse(ownProps.location.search);

	return {
		isAuthenticated: state.auth.isAuthenticated,
		passwordResetToken
	};
};

export default connect(mapStateToProps, {
	resetPassword
})(withTranslation()(ResetPassword));